import { Validation } from '@core/app/scripts/services/validation';

/**
 * @ngdoc directive
 * @name v6CoreModule.directive:fixed
 * @deprecated
 * @description
 * Fixed validation directive
 *
 * TODO POS-551 remove the directive
 * The name is misnomer; it works only in one direction, doesn't update view on
 * model change; cast numbers into strings; doesn't normalize view on blur.
 *
 * Deprecated in favor of shared.swNumber.
 */
angular
  .module('v6CoreModule')
  .directive('fixed', ($locale: ng.ILocaleService, validation: Validation) => {
    let seperator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
    if (!seperator) {
      seperator = '.';
    }
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        if (!ctrl) {
          return;
        }
        ctrl.$parsers.unshift((viewValue) => {
          const v = validation.correct(viewValue, 'fixed', attrs.fixed);
          let s = String(v);
          if (viewValue) {
            s = s.replace('.', seperator);
          }
          if (s != viewValue) {
            //change what's shown in the box
            ctrl.$setViewValue(s);
            ctrl.$render();
          }
          //actual update to the model
          return v;
        });
      },
    };
  });
